import { ForbiddenState } from '../../shared/ui/states';
import { StorageOverview } from '../../features/storage-overview';
import { StorageContents } from '../../features/storage-contents';
import { RetentionLevels } from '../../features/retention-levels';
import { DeleteNow } from '../../features/storage-delete';
import { SettingsShell } from './settings-shell';
import { useOrganizationSettings } from './use-organization-settings';

const BIGGEST = 'biggest-flows';
const DELETE_NOW = 'delete-now';

/** Boards S1–S3: how much is stored, for how long, and what gets deleted next. */
export const StoragePage = () => {
  const { organization, actor, timeZone } = useOrganizationSettings();
  const owner = actor?.role === 'owner';
  const name = organization.data?.name;
  const now = Date.now();
  const scrollTo = (id: string) => () =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <SettingsShell
      active="/settings/storage"
      question="How much you store, for how long, and what gets deleted next."
    >
      {actor && !owner && <ForbiddenState needs="owner" />}
      {owner && (
        <>
          <StorageOverview
            now={now}
            timeZone={timeZone}
            onBiggest={scrollTo(BIGGEST)}
            onDeleteNow={scrollTo(DELETE_NOW)}
          />
          <StorageContents />
          <RetentionLevels now={now} biggestId={BIGGEST} />
          {name && <DeleteNow id={DELETE_NOW} organizationName={name} timeZone={timeZone} />}
        </>
      )}
    </SettingsShell>
  );
};
